import { render, staticRenderFns } from "./KernelDashboard.vue?vue&type=template&id=dc5e0552&"
import script from "./KernelDashboard.vue?vue&type=script&lang=js&"
export * from "./KernelDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports